var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmilingCorporateMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "#F7F7F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.5C18.1272 8.5 19.2082 8.94777 20.0052 9.7448C20.8022 10.5418 21.25 11.6228 21.25 12.75C21.25 13.8772 20.8022 14.9582 20.0052 15.7552C19.2082 16.5522 18.1272 17 17 17C15.8728 17 14.7918 16.5522 13.9948 15.7552C13.1978 14.9582 12.75 13.8772 12.75 12.75C12.75 11.6228 13.1978 10.5418 13.9948 9.7448C14.7918 8.94777 15.8728 8.5 17 8.5ZM17 19.125C21.6963 19.125 25.5 21.0269 25.5 23.375V25.5H8.5V23.375C8.5 21.0269 12.3037 19.125 17 19.125Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmilingCorporateMale);
export default __webpack_public_path__ + "static/media/smiling-corporate-male.67dca370cf9611413cd8f76aee005d64.svg";
export { ForwardRef as ReactComponent };